export default "__VITE_ASSET__Cs7kHIvK__"